(function () {
    keepAlive();
    initNewsletter();

    function initNewsletter() {
        if (params && params.url != 'web') {
            return;
        }

        const newsletterState = localStorage.getItem('newsletter');

        if (newsletterState) return;

        xdialog.modal.show(null, '/naujienlaiskio-prenumerata/actions/modal', () => {
            const btn = document.getElementById('newsletter-reject-btn');

            if (!btn) return;

            btn.addEventListener('click', () => {
                setNewsletterState();
                xdialog.modal.close();
            });

            const newsletterLink = document.getElementById('newsletter-link');
            if (newsletterLink) {
                newsletterLink.addEventListener('click', (e) => {
                    e.preventDefault();

                    setNewsletterState();

                    window.location.href = newsletterLink.href;
                });
            }
        });

        $(document).on('hidden.bs.modal', function (e) {
            setNewsletterState();
        });

        window['newsletterModalCallback'] = (success) => {
            if (success) {
                setNewsletterState();
                xdialog.notify.show('Išsaugota', '', 'success')
                xdialog.modal.close();
            }
        }

        function setNewsletterState() {
            localStorage.setItem('newsletter', '1');
        }
    }

    function keepAlive() {
        const interval = setInterval(() => {
            fetch('/unique/keepalive.php')
                .then((resp) => {
                    if (resp.status !== 200) {
                        throw new Error(`keepAlive response code: ${resp.status}`);
                    }
                    return resp.json();
                })
                .then((resp) => {
                    if (!resp?.success) {
                        throw new Error('Invalid keepAlive response');
                    }
                })
                .catch((err) => {
                    console.error(err);
                    console.error('keepAlive failed');
                    clearInterval(interval);
                });
        }, 10 * 60 * 1000); // 10 min
    }
})();

